module.exports = __webpack_public_path__ + "static/media/industry_analyst_report_placeholder.c7115bdd.png";